export default "__VITE_ASSET__wXQ$ng70__"